<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">增票资质审核</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="130px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核状态:">
              <el-select v-model="formInline.auditStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
                <el-option label="待审核" value="APPLY"></el-option>
                <el-option label="审核拒绝" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="date" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions"
                format="yyyy - MM - dd " value-format="yyyy-MM-dd" @change="changeDate" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 0, searchApplyCertification(queryInfo)" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="store.code" label="平台号" min-width="10px"></el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="10px"></el-table-column>
          <el-table-column prop="store.salesman.fullName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="companyName" label="企业名称" min-width="10"></el-table-column>
          <el-table-column prop="dateCreated" label="申请日期" min-width="10"></el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" v-if="scope.row.auditStatus === 'APPLY' && $hasPermission('epay:admin:certification:audit')" @click="toExamine(scope.row, 'audit')"
                ref="operationRef">待审核<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus === 'AUDITED' && $hasPermission('epay:admin:certification:detail')" @click="toExamine(scope.row, 'detail')"
                ref="operationRef">已审核<br></span>
              <span v-if="scope.row.auditStatus === 'REJECTED'">已拒绝<br></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <!-- <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination> -->
      <div class="vm-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum + 1" :page-size="queryInfo.pageSize"
          layout="prev, pager, next, jumper" :total="queryInfo.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import VPagination from '@/components/Pagination/index.vue'
import { storeQueryListByCode, storeQueryListByName, getSalesmanByFullName } from '@/api/crm'
import { searchApplyCertification } from '@/api/finance'
export default {
  name: 'certification-message',
  components: {
    // VPagination
  },
  data () {
    return {
      salemanList: [],
      storeListByCode: [],
      formInline: {
        auditStatus: '',
        dateEnd: '',
        dateStart: '',
        salesmanId: '',
        storeId: ''
      },
      date: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      queryInfo: {
        pageNum: 0, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.searchApplyCertification(this.queryInfo)
  },
  watch: {
    date (val) {
      if (val) {
        this.formInline.dateStart = val[0]
        this.formInline.dateEnd = val[1]
      } else {
        this.formInline.dateStart = ''
        this.formInline.dateEnd = ''
      }
    }
  },
  methods: {
    toExamine (row, type) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      this.$router.push({ path: '/certificationAudit', query: { row: row, operationType: type } })
    },
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
    },
    handleCurrentChange (val) {
      console.log(val)
      this.queryInfo.pageNum = val - 1
      this.changePage(this.queryInfo)
      // this.$emit('changePage', this.queryInfo)
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    searchApplyCertification (val) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      searchApplyCertification({ pageNum: val.pageNum, pageSize: val.pageSize, certificationVo: param }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.content
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchApplyCertification(this.queryInfo)
    },
    changeDate (val) {
      if (val) {
        this.formInline.dateStart = val[0]
        this.formInline.dateEnd = val[1]
      } else {
        this.formInline.dateStart = ''
        this.formInline.dateEnd = ''
      }
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.vm-pagination {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0;
  display: flex;
  justify-content: center;

  @{deep}.el-pagination {
    .el-pager {
      li {
        background: #fff;
        min-width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 3px;
        border: 1px solid #e4e4e4;
      }

      .active {
        background-color: #666666 !important;
        color: #fff;
      }
    }

    button {
      line-height: 35px;
      height: 35px;
    }

    .el-input--mini .el-input__inner,
    .el-pagination__jump {
      height: 35px;
      line-height: 35px;
    }
  }
}
</style>
